module.exports = "<p>\r\n  t2-footer-main works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-footer-main/t2-footer-main.component.html
// module id = 2575
// module chunks = 66